/**
 * @file user-saved-data.ts
 * @description Сервис для работы с пользовательскими сохраненными данными в Task Manager. Обеспечивает сохранение и получение пользовательских настроек, предпочтений, фильтров и других персонализированных данных.
 * @author AI-Generated | Human-Reviewed
 * @created 2025-01-15
 * @updated 2025-01-15
 * @dependencies ['@src/types', '../actions.js', 'axios']
 * @related-files ['C:\laragon\www\task-manager\src\api\actions.js', 'C:\laragon\www\task-manager\src\types\index.ts']
 */

import { TApiData } from '@src/types';
import { getRequest, postRequest } from '../actions.js';
import { AxiosError, AxiosResponse } from 'axios';

export const UserSavedDataService = {
    /**
     * Получает сохраненные пользовательские данные по названию настройки
     * @param {string} name - Название настройки или группы настроек
     * @param {string} key - Дополнительный ключ для конкретной настройки
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с данными настроек пользователя или ошибкой
     */
    get: async (name: string, key?: string): Promise<AxiosResponse | AxiosError> => {
        return await getRequest(`setting/${name}`, key ? { key } : undefined);
    },
    
    /**
     * Создает или обновляет пользовательские сохраненные данные
     * @param {string} name - Название настройки или группы настроек
     * @param {string} key - Ключ для конкретной настройки
     * @param {TApiData} data - Данные для сохранения в настройках пользователя
     * @returns {Promise<AxiosResponse | AxiosError>} Промис с результатом сохранения или ошибкой
     */
    create: async (name: string, key: string, data: TApiData): Promise<AxiosResponse | AxiosError> => {
        return await postRequest(`setting/${name}`, data, { key }, { headers: { 'Content-Type': 'text/plain' } });
    }
};
